<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="channel-type-breakdown-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
          </button>

          <h4 class="modal-title">
            Publication Breakdown
          </h4>
        </div>

        <LoadingSpinner v-if="loading"/>

        <div v-else class="modal-body">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="col-xs-6">
                Company
              </th>

              <th class="col-xs-4">
                Order
              </th>

              <th class="col-xs-5">
                Portal
              </th>

              <th class="col-xs-5">
                Category
              </th>

              <th class="col-xs-4 text-right">
                Price
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="row in rows">
              <td class="table__ellipsis">
                <router-link :to="'/companies/' + row.company_id" data-dismiss="modal">
                  {{ row.company_name }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/companies/' + row.company_id + '/orders/' + row.order_id" data-dismiss="modal">
                  #{{ row.order_id }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/portals/' + row.portal_id" data-dismiss="modal">
                  {{ row.portal_name }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                  <span v-if="row.ad_category === 'publication-ads'" class="label label-success">
                    Publication
                  </span>

                <span v-if="row.ad_category === 'time-ads'" class="label label-info">
                    Time
                  </span>
              </td>

              <td class="table__ellipsis text-right">
                {{ row.price | price }}
              </td>
            </tr>
            </tbody>

            <tfoot>
            <tr>
              <td colspan="4" class="text-right">
                <b>
                  Total
                </b>
              </td>

              <td class="text-right">
                <b>
                  {{ total | price }}
                </b>
              </td>
            </tr>
            </tfoot>
          </table>

          <SimplePager :current-page="page" :last-page="lastPage" @navigate="page = $event"/>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SimplePager from '../../../Lists/SimplePager'

export default {
  components: {SimplePager, LoadingSpinner},

  props: {
    period: {
      required: true
    },

    portal: {
      required: false
    },

    dataset: {
      required: false
    }
  },

  data() {
    return {
      data: null,

      page: 1,
      loading: true
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    period() {
      this.load()
    },
    
    portal() {
      this.load()
    },

    dataset() {
      this.load()
    },
  },

  computed: {
    rows() {
      return this.data.slice((this.page - 1) * 10, this.page * 10)
    },

    lastPage() {
      return Math.ceil(this.data.length / 10)
    },

    total() {
      return Math.round(this.data.reduce((total, row) => parseFloat(row.price) + total, 0))
    },
  },

  methods: {
    load() {
      this.loading = true

      http.post('/api/v1/reports/channel-type-breakdown', {
        period: this.period,
        portal_id: this.portal,
        dataset_id: this.dataset,
      }).then(response => {
        this.data = response.data.data

        this.data.sort((a, b) => a.company_name < b.company_name ? -1 : 1)

        this.loading = false
      })
    },

    hide() {
      $(this.$el).modal('hide')
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.page = 1
    }
  }
}
</script>
